import styled, { css } from 'styled-components';
import { BorderBottom } from '../../../../../src/styled/shared-styles';
import { getColorShade, getSizeBy } from '../../../../../src/styled/utils';
import { Tooltip } from './../../../tooltip/tooltip';
const heightCSS = css `
  height: ${getSizeBy(11)};
`;
const minHeightCSS = css `
  min-height: ${getSizeBy(11)};
`;
const blockTableHeight = ({ as }) => {
    if (as === 'div')
        return minHeightCSS;
    return heightCSS;
};
export const StyledBodyRow = styled.tr `
  &:not(:last-child) {
    ${BorderBottom}
  }

  background-color: ${({ isSelected }) => isSelected && getColorShade('primary', 'selected')};
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')} !important;
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.5 : 1)} !important;
  ${blockTableHeight}

  & td.pinned::before {
    background-color: ${({ isSelected }) => isSelected && getColorShade('primary', 'selected')};
  }

  &:hover {
    background-color: ${({ isSelected }) => !isSelected && getColorShade('primary', 'hover')};

    & td.pinned::before {
      background-color: ${({ isSelected }) => !isSelected && getColorShade('primary', 'hover')};
    }
  }
`;
export const StyledTooltip = styled(Tooltip) ``;
